<div class="signupContent">
    <form class="login100-form validate-form">
        <div class="d-flex">
            <div class="wrap-input100 validate-input mr-4">
                <input class="input100" type="text" [(ngModel)]="customer.lastname" name="lastname" placeholder="Nom">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
            <div class="wrap-input100 validate-input">
                <input class="input100" type="text" [(ngModel)]="customer.phone" name="phone" placeholder="Téléphone">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
        </div>
        <div class="wrap-input100 validate-input">
            <input class="input100" type="text" [(ngModel)]="customer.email" name="email" placeholder="Email">
            <span class="focus-input100"></span>
            <span class="symbol-input100">
                <i class="glyphicon glyphicon-arrow-right"></i>
            </span>
        </div>
        <div class="d-flex">
            <div class="wrap-input100 validate-input mr-4">
                <input class="input100" type="password" [(ngModel)]="customer.password" spellcheck=false name="pass"
                    placeholder="Mot de passe">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
            <div class="wrap-input100 validate-input">
                <input class="input100" type="password" [(ngModel)]="customer.confirmePassword" spellcheck=false
                    name="confirmePassword" placeholder="Confirmation Mot de passe">
                <span class="focus-input100"></span>
                <span class="symbol-input100">
                    <i class="glyphicon glyphicon-arrow-right"></i>
                </span>
            </div>
        </div>
        <div class="container-login100-form-btn">
            <button class="login100-form-btn" (click)="signup()" [disabled]="loader">
                <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;
                </ng-container>
                S'inscrire
            </button>
        </div>
        <div class="footer justify-content-between">
            <p>Après l'inscription, merci de consulter votre boite e-mail pour valider votre inscription.</p>
            <button routerLink="../connexion" class="login-btn">
                Se connecter &nbsp;&nbsp;
                <i class="glyphicon glyphicon-arrow-right"></i>
            </button>
        </div>
    </form>
</div>